module.exports = __webpack_public_path__ + "assets/edit-6ee69a978504cb85d0d0bc0195eb037c.svg";